import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppService } from '../../app.service';
import { GlobalService } from '../../global/services/global.service';
import { WorkspaceService } from '../../workspace/workspace.service';
import { generalConfigFromGlobal } from '../../shared/workspace-element-context';
import { ScreenDocumentList } from './screen-document';
import { ScreenDocumentService } from './screen-document.service';
import { User } from '../user';
import { UserService } from '../user.service';
import { createGtwAppkitTextEditorConfig } from '../../shared/_config/gtw-appkit-text-editor.config';

@Component({
    selector: 'gtw-screen-document-upload',
    templateUrl: './screen-document-upload.component.html',
    styleUrls: ['./screen-document-upload.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ScreenDocumentUploadComponent implements OnInit, OnChanges, AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);

  data: any;
  hdKey: number | undefined;
  durationInSeconds = 5;

  @Input('childTabIndex')
  childTabIndex: number = 0;

  public docTitle: string = '';
  public editData: any;

  @Input() attachmentList: any = [];
  @Input() fromUpload: boolean = false;

  screenDocumentAttachedList: Array<ScreenDocumentList> = [];

  @Input('updateDocSelected')
  set updateDocSelectedInput(Document: ScreenDocumentList) {
    if (Document) {
      this.docTitle = Document.hd_msg_title;
      this.data = Document.hd_body;
      this.text1 = Document.hd_body;
      this.hdKey = Document.hd_key;
    }
  }

  currentFileUpload: any;
  @Output()
  refreshScreenDocumentList = new EventEmitter<boolean>();

  readonly docUploadEditorConfig = createGtwAppkitTextEditorConfig('Enter document content');

  text1: string = '';

  ngOnInit(): void {
    const u = this.gtwApp.USER_SETTINGS?.user as User | undefined;
    if (u) {
      this.userService.setUser(u);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('text tags', this.text1);
  }

  onChange(_event: any) {
    console.log('text tags', this.text1);
  }

  ngAfterViewInit(): void {
    console.log('text tags', this.text1);
  }

  constructor(
    public gtwGlobal: GlobalService,
    public gtwWorkspace: WorkspaceService,
    public gtwApp: AppService,
    private userService: UserService,
    private screenDocumentService: ScreenDocumentService,
    private _snackBar: MatSnackBar
  ) {}

  private activeScreen(): any {
    return this.gtwWorkspace.workspaceFactory?.activeScreen || {};
  }

  private getBaseUrl(): string {
    const gc = generalConfigFromGlobal(this.gtwGlobal);
    return String(gc.base_url ?? gc.api ?? '');
  }

  get screenKeyNum(): number {
    const a = this.activeScreen();
    const raw = a.link ?? a.screenKey ?? a.screen_key;
    return parseInt(String(raw), 10);
  }

  get clientKeyNum(): number {
    const raw =
      this.gtwGlobal.global?.globalParams?.client_key ?? this.gtwApp.USER_SETTINGS?.user?.client_key;
    return parseInt(String(raw), 10);
  }

  loadDocUploadTab(event: any) {
    console.log('I am listed', event);
  }

  saveDocument(_event: any) {
    console.log('I am saving', this.data);
    const hdKey = this.hdKey != 0 ? this.hdKey : '';
    if (this.docTitle == '' || this.editData == '') {
      this.openSnackBar('Please add the title and doc content !!');
      return;
    }
    this.screenDocumentService
      .uploadDocument(
        this.getBaseUrl(),
        this.clientKeyNum,
        this.screenKeyNum,
        this.docTitle,
        this.editData,
        hdKey
      ).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (res) => {
          if (res.callSuccess == 1 || parseInt(res.callSuccess) == 1) {
            this.docTitle = '';
            this.text1 = '';
            this.openSnackBar('Document Saved Successfully !!');

            this.refreshScreenDocumentList.emit(true);
          } else {
            this.openSnackBar(res.errorMessage);
          }
        },
        () => {}
      );
  }

  deleteDocument(event: any, object: any) {
    console.log('I am deleted', event);
    console.log('I am deleted', object);
  }

  uploadDocument(event: any) {
    for (let i = 0; i < event.target.files.length; i++) {
      this.attachmentList.push(event.target.files[i]);
    }
    console.log('I amcalled', this.attachmentList);
  }

  ngOnDestroy(): void {
    console.log('to do');
  }

  private openSnackBar(message: string) {
    this._snackBar.open(message, '', {
      duration: this.durationInSeconds * 1000,
    });
  }

  clearContent(_event: any) {
    this.docTitle = '';
    this.data = '';
    this.text1 = '';
    this.hdKey = 0;
  }

  ngDoCheck() {
    this.editData = this.text1;
  }
}
